// src/app/shared/app-links.ts

export const AppLinks = {
  home: 'https://chemrobotics.com/',
  aboutUs: 'https://www.chemrobotics.com/about-us',
  advisory: 'https://www.chemrobotics.com/advisory', // New link
  awardsRecognition: 'https://www.chemrobotics.com/awards-recognition',
  clients: 'https://www.chemrobotics.com/clients', // Updated to include full URL
  career: 'https://www.chemrobotics.com/career', // Updated to include full URL
  contactUs: 'https://www.chemrobotics.com/contact', // Updated to include full URL
  gallery: 'https://www.chemrobotics.com/gallery', // New link
  ourEvents: 'https://www.chemrobotics.com/our-events', // New link
  ourPartners: 'https://www.chemrobotics.com/our-partners', // New link
  ourStory: 'https://www.chemrobotics.com/our-story', // New link
  ourTeam: 'https://www.chemrobotics.com/our-teams', // New link
  pressRelease: 'https://www.chemrobotics.com/press-release', // New link
  autoRegulatory: 'https://www.chemrobotics.com/agro-regulatory', // New link
  Ethics: 'https://www.chemrobotics.com/ethics', // New link
  trainingVideos: 'https://www.chemrobotics.com/training-videos',
  demoRequest: 'https://www.chemrobotics.com/demo_request',
  Brochure:
    'https://www.chemrobotics.com/agropat/assets/CHEMROBOTICS_Brochure_2020.pdf',
  signUppage: 'https://www.chemrobotics.com/registration',
  patentIndia: 'https://www.chemrobotics.com/patent-india',
  pharmaDatabase: 'https://chemroboticspharma.com/pharmVetPat',
  profile: 'https://wwww.chemrobotics.com/profile',
  settings: 'https://www.chemrobotics.com/edit_profile',
  social: {
    facebook: 'https://www.facebook.com/ChemRobotics',
    linkedin: 'https://www.linkedin.com/company/chemrobotics/',
    youtube: 'https://www.youtube.com/channel/UCl21pDcr00u_asN6gCJ6hfQ',
    instagram: 'https://www.instagram.com/chemrobotics/',
  },
  whatsappInvite: 'https://chat.whatsapp.com/HQ4vy7F2g1AKuGXOqk7CkQ',
  phone: 'tel:+916266117944',
  email: 'mailto:support@chemrobotics.com',
};
